import { Layer, LayerType } from './layer';
import { LocationType } from './imageLayer';

export class VideoLayer extends Layer {
    public originalWidth = 0;

    public originalHeight = 0;

    public locationType: LocationType = LocationType.local;

    public location: string | null = null;

    public removeAudio: boolean | undefined = false;

    public lockAspectRatio = true;

    public constructor(id: number) {
        super(id, LayerType.video);
    }
}

export function isVideoLayer(layer: Layer): layer is VideoLayer {
    return layer.type === LayerType.video;
}
